import { Divider, Flex, Heading } from '@zillow/constellation';
import { useEffect } from 'react';
import InviteToApplyLinks from '../../../../components/InviteToApplyLinks/InviteToApplyLinks';
import { orderBy } from 'lodash';
import Invitation from '../../../ApplicationsTabPage/ListingApplicationsTab/ListingApplications/Invitation';
import InvitedCard from './InvitedCard';
import { newInviteStatusSelector } from '../../../../selectors';
import { useSelector } from 'react-redux';
import { getGraphqlQueryKey } from '../../../../hooks/useGraphqlQuery';
import { APPLICATIONS_DASHBOARD_QUERY } from '../../../../constants/queries';
import useQueryVariables from '../../../../hooks/useQueryVariables';
import { useQueryClient } from '@zg-rentals/react-query5';
import {
  emitZtssCopyInviteLinkEvent,
  emitZtssDashboardInviteEvent,
} from '../../../../../client/analytics/clickstreamEvents';
import { useListingUser } from '../../../../hooks/useListingUser';

export default function InvitedSection({ data }) {
  const newInviteStatus = useSelector(newInviteStatusSelector);
  const { propertyId } = useQueryVariables();
  const queryClient = useQueryClient();
  const { user, listing } = useListingUser();

  useEffect(() => {
    if (newInviteStatus === 'success') {
      queryClient.refetchQueries({
        queryKey: getGraphqlQueryKey(APPLICATIONS_DASHBOARD_QUERY, { listingAlias: propertyId }),
      });
    }
  }, [newInviteStatus, propertyId, queryClient]);
  const { invitationsToApply } = data.rentalListing;
  const sortedInvitationsToApply = orderBy(invitationsToApply, ['invitedDateTime'], ['desc']);
  const lastInvitation = sortedInvitationsToApply.pop();
  return (
    <Flex display="flex" flexDirection="column">
      <Flex
        display="flex"
        flexDirection={{ default: 'column', md: 'row' }}
        justifyContent="space-between"
        alignItems="center"
        marginBottom="sm"
      >
        <Heading level={4}>Invited applicants</Heading>
        <InviteToApplyLinks onCopyLinkAnalyticsCallback={() => emitZtssCopyInviteLinkEvent(listing, user)} />
      </Flex>
      <Flex display="flex" flexDirection="column">
        {sortedInvitationsToApply.map((invitationToApply) => (
          <>
            <InvitedCard key={invitationToApply.id} invitationToApply={invitationToApply} />
            <Divider marginY="xs" />
          </>
        ))}
        {lastInvitation && <InvitedCard invitationToApply={lastInvitation} />}
      </Flex>
      <Divider />
      <Invitation onSubmitAnalyticsCallback={() => emitZtssDashboardInviteEvent(listing, user)} />
    </Flex>
  );
}
